import logger from '@/utils/logger';
import { Session } from 'next-auth';
import { getSession } from 'next-auth/react';
import { auth } from '../lib/auth';
import { isServer } from '@/utils/util';

// 세션 캐싱 관련 설정
const SESSION_CACHE_TTL_MS = 30 * 1000; // 30초 캐시 유효 시간

// 세션 캐시 상태
let cachedSession: Session | null = null;
let cacheTimestamp = 0;

/**
 * 세션 정보를 캐싱하여 제공하는 함수
 * 캐시 유효 시간 내에는 저장된 세션을 반환, 만료되면 새로 요청
 */
export const getCachedSession = async (): Promise<Session | null> => {
  const now = Date.now();
  
  // 캐시가 유효한 경우 저장된 세션 반환
  if (cachedSession && now - cacheTimestamp < SESSION_CACHE_TTL_MS) {
    return cachedSession;
  }
  
  try {
    // 서버 환경과 클라이언트 환경에 따라 세션 가져오기
    const session = isServer() ? await auth() : await getSession();
    
    // 세션 캐싱
    cachedSession = session;
    cacheTimestamp = now;
    
    return session;
  } catch (error) {
    logger.error('Session retrieval error:', error);
    return null;
  }
};

/**
 * 세션 캐시 무효화 함수
 * 세션 상태가 변경될 때 호출하여 강제로 다음 요청에서 세션을 다시 가져오도록 함
 */
export const invalidateSessionCache = (): void => {
  cachedSession = null;
  cacheTimestamp = 0;
  logger.info('Session cache invalidated');
};